var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.item.cityName && _vm.item.cityName != "",
              expression: "item.cityName&&item.cityName!=''",
            },
          ],
        },
        [_vm._v("会议/活动地点：" + _vm._s(_vm.item.cityName) + "/")]
      ),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.item.useDay != "",
              expression: "item.useDay!=''",
            },
          ],
        },
        [_vm._v(_vm._s(_vm.item.useDay))]
      ),
      _vm.item.activeType && _vm.item.activeType != ""
        ? _c("span", [
            _c("i", [_vm._v("/")]),
            _vm._v(_vm._s(_vm.item.activeType)),
          ])
        : _vm._e(),
      _vm.item.peopleType == 1
        ? _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.item.peopleNumber != "",
                  expression: "item.peopleNumber!=''",
                },
              ],
            },
            [
              _c("i", [_vm._v("/")]),
              _vm._v(_vm._s(_vm.item.peopleNumber) + "人"),
            ]
          )
        : _vm._e(),
      _vm.item.peopleType == 2
        ? _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.item.peopleNumRange != "",
                  expression: "item.peopleNumRange!=''",
                },
              ],
            },
            [_c("i", [_vm._v("/")]), _vm._v(_vm._s(_vm.item.peopleNumRange))]
          )
        : _vm._e(),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.item.budgetPrice && _vm.item.budgetPrice != "",
              expression: "item.budgetPrice&&item.budgetPrice!=''",
            },
          ],
        },
        [
          _c("i", [_vm._v("/")]),
          _vm._v(_vm._s(_vm.item.budgetPrice) + _vm._s(_vm.item.currency)),
        ]
      ),
      _vm._l(_vm.item.containServiceMap, function (values, key) {
        return _c(
          "span",
          { key: key },
          _vm._l(values, function (item2, index1) {
            return _c("span", { key: index1 }, [
              _vm._v(" " + _vm._s(item2) + " "),
              index1 != values.length - 1
                ? _c("span", [_vm._v("+")])
                : _vm._e(),
            ])
          }),
          0
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }